import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=614d70b6&scoped=true&"
import script from "./Terminos.vue?vue&type=script&lang=js&"
export * from "./Terminos.vue?vue&type=script&lang=js&"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=614d70b6&scoped=true&lang=css&"
import style1 from "./Terminos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d70b6",
  null
  
)

export default component.exports